import React from "react";
import { SEO } from "../components/SEO";

export const Termos = () => {
  return (
    <div className="bg-slate-50 min-h-screen py-20">
      <SEO 
        title="Termos de Uso - RosTech" 
        description="Termos de uso do sistema RosTech."
        canonicalUrl="/termos"
      />
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-slate-100">
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Termos de Uso</h1>
          
          <div className="prose prose-slate max-w-none prose-h2:text-2xl prose-h2:font-bold prose-h2:mt-8 prose-h2:mb-4 prose-p:text-slate-600 prose-p:leading-relaxed">
            <p className="text-lg text-slate-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o sistema RosTech, você aceita e concorda em estar vinculado pelos termos e 
              disposições deste acordo. Além disso, ao usar os serviços deste sistema, você estará sujeito a 
              quaisquer diretrizes ou regras aplicáveis atualizadas conforme necessário.
            </p>

            <h2>2. Descrição do Serviço</h2>
            <p>
              O RosTech é um sistema de ERP e CRM focado em oficinas mecânicas, oferecendo controle de estoque, 
              gestão financeira, cadastro de clientes, e funcionalidades de PDV.
            </p>

            <h2>3. Contas de Usuário</h2>
            <p>
              Para acessar a maioria dos recursos do sistema, você precisará se registrar. Ao se cadastrar, 
              você concorda em fornecer informações precisas e completas. Você é o único responsável pela 
              atividade que ocorre em sua conta, e deve manter a senha de sua conta segura.
            </p>

            <h2>4. Uso Aceitável</h2>
            <p>
              Você concorda em não usar o sistema de maneira que possa danificar, desativar, sobrecarregar ou 
              prejudicar qualquer servidor do RosTech, ou interferir no uso de qualquer outra parte. É estritamente 
              proibido o uso do serviço para qualquer fim ilegal ou não autorizado.
            </p>

            <h2>5. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo presente no sistema, incluindo, mas não se limitando a, textos, gráficos, logos, 
              ícones de botões, imagens, clipes de áudio, downloads digitais e compilações de dados, é propriedade 
              do RosTech ou de seus fornecedores de conteúdo e é protegido por leis de direitos autorais internacionais.
            </p>

            <h2>6. Limitação de Responsabilidade</h2>
            <p>
              O RosTech não será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais 
              ou punitivos, ou qualquer perda de lucros ou receitas, seja incorrida direta ou indiretamente, ou 
              qualquer perda de dados, uso, boa-vontade, ou outras perdas intangíveis.
            </p>

            <h2>7. Modificações dos Termos</h2>
            <p>
              O RosTech reserva-se o direito de modificar estes termos a qualquer momento. Tais modificações 
              entrarão em vigor imediatamente após a publicação. Você reconhece e concorda que é sua responsabilidade 
              revisar este acordo periodicamente para se familiarizar com quaisquer modificações.
            </p>

            <h2>8. Contato</h2>
            <p>
              Em caso de dúvidas sobre estes Termos de Uso, entre em contato conosco pelos canais abaixo:
              <br />
              <strong>Telefone / WhatsApp:</strong> (24) 9.9281-8632
              <br />
              <strong>E-mail:</strong> devckout@gmail.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
